"use strict";
/**
 * Created by jonas on 2020-09-15.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowState = void 0;
var FlowState;
(function (FlowState) {
    FlowState["IDLE"] = "IDLE";
    FlowState["BET"] = "BET";
    FlowState["RESULT"] = "RESULT";
    FlowState["WIN"] = "WIN";
})(FlowState || (exports.FlowState = FlowState = {}));
//# sourceMappingURL=FlowState.js.map